import { render } from "./TrainingAttending.vue?vue&type=template&id=0086b8ba&scoped=true"
import script from "./TrainingAttending.vue?vue&type=script&lang=js"
export * from "./TrainingAttending.vue?vue&type=script&lang=js"

import "./TrainingAttending.vue?vue&type=style&index=0&id=0086b8ba&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0086b8ba"]])

export default __exports__